import * as React from 'react';
import Spinner from 'ted-ui/build/Spinner';
import Spacing from '@able/react/dist/Spacing';

const OrderLoading = () => {
  return (
    <Spacing top="spacing10x">
        <Spinner
            centered
            imageScreenReaderContent="Loading Results"
            isLoading
            label="Loading"
            size="48"
            variant="Vertical"
        />
    </Spacing>
  );
};

export default OrderLoading;
